import { useMutation, useQuery, useQueryClient } from 'react-query';
import { createAbsenceType, deleteAbsenceType, fetchAbsenceTypes, updateAbsenceType, } from '@/features/absenceType/services/absenceTypeService';
const useAbsenceTypes = (page = 1, filters = {}, all = false, limit = 10) => {
    const queryClient = useQueryClient();
    const { data, error, isLoading, refetch } = useQuery(['absenceTypes', { page, filters, all, limit }], () => fetchAbsenceTypes(page, filters, all, limit), {
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000,
    });
    const createMutation = useMutation((payload) => createAbsenceType(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('absenceTypes');
        },
    });
    const updateMutation = useMutation((payload) => updateAbsenceType(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('absenceTypes');
        },
    });
    const deleteMutation = useMutation((id) => deleteAbsenceType(id), {
        onSuccess: () => {
            queryClient.invalidateQueries('absenceTypes');
        },
    });
    return {
        absenceTypes: data?.absenceTypes ?? [],
        meta: data?.meta ?? null,
        loading: isLoading,
        error: error?.message ?? null,
        handleCreateAbsenceType: createMutation.mutateAsync,
        handleUpdateAbsenceType: updateMutation.mutateAsync,
        handleDeleteAbsenceType: deleteMutation.mutateAsync,
        refetchAbsenceTypes: refetch,
    };
};
export default useAbsenceTypes;
